export const META_ADS_UTM_TEMPLATE =
  'utm_source={{site_source_name}}&utm_medium=paid_social&utm_campaign={{campaign.name}}&utm_campaign_id={{campaign.id}}&utm_adset={{adset.name}}&utm_adset_id={{adset.id}}&utm_content={{ad.name}}&utm_ad_id={{ad.id}}&utm_placement={{placement}}';

export function getMetaAdsUtmTemplate() {
  return META_ADS_UTM_TEMPLATE;
}

